import { faInstagram, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faBrain, faBriefcase, faCode, faEnvelope, faGraduationCap, faUserAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Link } from "react-router-dom";


const Header = () => {

    const [isOpen, setIsOpen] = useState(false);


    return (

        <header>
            <nav>

                <div className="navbar">

                    <Link to="/" className="logo-topbar" aria-label="Retour à l'accueil">Cody MACEDO</Link>
                    <div className="menu-fullscreen">
                        <ul>
                            <li>
                                <a href="#resume" className="nav-item" aria-label="Accueil" title="Accueil">
                                    <FontAwesomeIcon icon={faUserAlt} />
                                    <span>Accueil</span>
                                </a>
                            </li>
                            <li>
                                <a href="#projects" className="nav-item" aria-label="Projets" title="Projets">
                                    <FontAwesomeIcon icon={faCode} />
                                    <span>Projets</span>
                                </a>
                            </li>
                            <li>
                                <a href="#skill" className="nav-item" aria-label="Compétences" title="Compétences">
                                    <FontAwesomeIcon icon={faBrain} />
                                    <span>Skills</span>
                                </a>
                            </li>
                            <li>
                                <a href="#experience" className="nav-item" aria-label="Expérience" title="Expérience">
                                    <FontAwesomeIcon icon={faBriefcase} />
                                    <span>Expérience</span>
                                </a>
                            </li>
                            <li>
                                <a href="#formation" className="nav-item" aria-label="Formation" title="Formation">
                                    <FontAwesomeIcon icon={faGraduationCap} />
                                    <span>Formation</span>
                                </a>
                            </li>
                            <li>
                                <Link to="/contact" className="nav-item" aria-label="Contact" title="Contact">
                                    <FontAwesomeIcon icon={faEnvelope} />
                                    <span>Contact</span>
                                </Link>
                            </li>
                            <li className="nav-right">
                                <a href="https://www.instagram.com/kydo.7/"
                                    target="_blank" rel="noreferrer" aria-label="Instagram"><FontAwesomeIcon
                                        icon={faInstagram} /></a>
                                <a href="https://www.linkedin.com/in/cody-macedo-dev/"
                                    target="_blank" rel="noreferrer" aria-label="LinkedIn"><FontAwesomeIcon
                                        icon={faLinkedin} /></a>
                            </li>
                        </ul>
                    </div>
                    <div className="menu-responsive">
                        <div id="mobile-menu" className={isOpen ? "mobile-menu open" : "mobile-menu"}>
                            <div className='mobile-menu-container'>
                                <div className='mobile-menu-li'>
                                    <a href="#resume" onClick={() => setIsOpen(!isOpen)}>
                                        <FontAwesomeIcon icon={faUserAlt} /> Accueil
                                    </a>
                                </div>
                                <div className='mobile-menu-li'>
                                    <a href="#projects" onClick={() => setIsOpen(!isOpen)}>
                                        <FontAwesomeIcon icon={faCode} /> Projets
                                    </a>
                                </div>
                                <div className='mobile-menu-li'><a href="#skill" onClick={() => setIsOpen(!isOpen)}><FontAwesomeIcon
                                    icon={faBrain} /> Skills</a>
                                </div>
                                <div className='mobile-menu-li'><a href="#experience"
                                    onClick={() => setIsOpen(!isOpen)}><FontAwesomeIcon
                                        icon={faBriefcase} /> Expérience</a>
                                </div>
                                <div className='mobile-menu-li'><a href="#formation" onClick={() => setIsOpen(!isOpen)}>
                                    <FontAwesomeIcon
                                        icon={faGraduationCap} /> Formation</a>
                                </div>
                                <div className='mobile-menu-li'><Link to="/contact" onClick={() => setIsOpen(!isOpen)}>
                                    <FontAwesomeIcon
                                        icon={faEnvelope} /> Contact</Link>
                                </div>
                            </div>

                            <div className='mobile-menu-socialnetwork '>
                                <a href="https://www.instagram.com/kydo.7/" target="_blank" rel="noreferrer" aria-label="Instagram">
                                    <FontAwesomeIcon icon={faInstagram} size='xl' />
                                </a>
                                <a href="https://www.linkedin.com/in/cody-macedo-dev/" target="_blank" rel="noreferrer" aria-label="LinkedIn">
                                    <FontAwesomeIcon icon={faLinkedin} size='xl' />
                                </a>
                            </div>
                        </div>
                    </div>
                    <button
                        type="button"
                        className={isOpen ? "menu-btn open" : "menu-btn"}
                        aria-label={isOpen ? "Fermer le menu" : "Ouvrir le menu"}
                        aria-expanded={isOpen}
                        aria-controls="mobile-menu"
                        onClick={() => setIsOpen(!isOpen)}
                    >
                        <span className="line" />
                        <span className="line" />
                        <span className="line" />
                    </button>
                </div>

            </nav>
        </header>

    );
}

export default Header;
